"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMatchingSingleRedirect = exports.isMatchingBulkRedirect = exports.isMatchingRedirect = void 0;
const jexl_1 = __importDefault(require("jexl"));
const ct_1 = require("../ct");
const cloudflare_redirects_1 = require("./cloudflare-redirects");
jexl_1.default.addBinaryOp('eq', 20, (left, right) => `${left}`.toLowerCase() === `${right}`.toLowerCase());
jexl_1.default.addBinaryOp('contains', 20, (left, right) => `${left}`.includes(right));
/**
 * Determines whether or not a url matches a single or bulk redirect configured in cloudflare
 *
 * Add a special condition around `fr-ca` locale.
 * The `fr-ca` locale for eCommerceCA is translated on the fly using OneLinke transperfect integration.
 * This means they take the `fr-ca` locale and translate convert it to `en-ca` in order to get english
 * content which in turn they translate on the fly into french canadian.
 * https://clarks.atlassian.net/browse/CICD-9285?focusedCommentId=393125
 * https://clarks.atlassian.net/browse/CICD-9285?focusedCommentId=393767
 */
const isMatchingRedirect = (url, channel, storefrontLocale) => {
    if (channel === ct_1.ChannelFromEvent.CA && storefrontLocale === 'fr-ca') {
        const enCaUrl = url.replace(/\/fr-ca\//g, '/en-ca/');
        return (0, exports.isMatchingRedirect)(enCaUrl);
    }
    return (0, exports.isMatchingBulkRedirect)(url) || (0, exports.isMatchingSingleRedirect)(url);
};
exports.isMatchingRedirect = isMatchingRedirect;
const isMatchingBulkRedirect = (url) => {
    return cloudflare_redirects_1.bulkRedirects.some(({ redirect }) => redirect.source_url === url);
};
exports.isMatchingBulkRedirect = isMatchingBulkRedirect;
const isMatchingSingleRedirect = (url) => {
    const context = {
        http: {
            request: {
                uri: new URL(url).pathname,
                full_uri: url,
            },
        },
    };
    for (const redirect of cloudflare_redirects_1.singleRedirects) {
        if (!redirect.enabled || !redirect.expression) {
            continue;
        }
        try {
            const expression = redirect.expression.replace(/ or /g, ' || ').replace(/ and /g, ' && ');
            const res = jexl_1.default.evalSync(expression, context);
            if (res === true) {
                return true;
            }
        }
        catch (err) {
            continue;
        }
    }
    return false;
};
exports.isMatchingSingleRedirect = isMatchingSingleRedirect;
//# sourceMappingURL=index.js.map